/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 配信目的
 * @export
 * @interface Purpose
 */
export interface Purpose {
    /**
     * 配信目的ID
     * @type {number}
     * @memberof Purpose
     */
    purposeId: number;
    /**
     * 配信目的名
     * @type {string}
     * @memberof Purpose
     */
    purposeName: string;
}

export function PurposeFromJSON(json: any): Purpose {
    return PurposeFromJSONTyped(json, false);
}

export function PurposeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Purpose {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purposeId': json['purpose_id'],
        'purposeName': json['purpose_name'],
    };
}

export function PurposeToJSON(value?: Purpose | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purpose_id': value.purposeId,
        'purpose_name': value.purposeName,
    };
}

